// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"2eb8393a","730":"a5efa586","787":"258290d4","911":"0d0cd8e0"}[chunkId] + ".chunk.js";
};